import LoadingBar from 'app/components/common/LoadingBar/LoadingBar';
import React, { useState } from 'react';

function useIsLoading() {
	const [isLoading, setIsLoading] = useState(false);
	const LoadingElement = () => <LoadingBar />;

	return {
		isLoading,
		setIsLoading,
		LoadingElement,
	};
}

export default useIsLoading;
